<mat-dialog-content class="p-0 m-0 overflow-hidden">
    <div *ngIf="selectedPlace === false">
        <form [formGroup]="relocateServiceForm" class="ml-1" >
            <h1 class="text-xl md:text-2xl font-bold mb-4">Relocate service</h1>
            <p class="font-bold text-md mb-6">
                Moving? Let us help take the stress out of it and see if your package is available at your new address.
            </p>
       
            <mat-form-field class="w-full rounded-2xl z-9999">
                <mat-label class="font-bold">Enter your location</mat-label>
                <input id="searchTextField" #searchTextRef matInput [formControlName]="'locationValue'"
                class="bg-white  w-full  p-5 rounded-xl" type="text"  
                placeholder="Enter and select address or coordinates" (keyup)="getPlaceAutocomplete()">
            </mat-form-field>
       
              <div class="flex flex-row justify-end">
                <button class="mt-2 text-lg font-bold mx-4 bg-gray-100" mat-flat-button (click)="closeDialog()">
                    Cancel
                </button>
                <button class="mt-2 text-lg font-bold mx-4 bg-accent" mat-flat-button (click)="proceed()" [disabled]="loading === true">
                    <ng-container *ngIf="loading === false; else showSpinner">
                        Proceed
                      </ng-container>
                      <ng-template #showSpinner>
                        <mat-spinner diameter="24"></mat-spinner>
                      </ng-template>
                </button>
            </div>
        </form> 
    </div>


    <div *ngIf="selectedPlace === true" >
        <div *ngIf="!LeadEntityID">
            <h1 class="text-xl md:text-2xl font-bold mb-4"  >Loading Packages</h1>
            <p class="font-bold text-md mb-6">
                Please wait..
            </p>
            <mat-spinner diameter="24"></mat-spinner>
        </div>
        
        <div *ngIf="packagesResult?.length >= 1 && LeadEntityID">
            <app-swiper-packages [Packages]="packagesResult" [LeadEntityID]="LeadEntityID" [DashboardView]="true"></app-swiper-packages>
        </div>
    </div>

 
   
    
</mat-dialog-content>